import React from 'react';
import PortableText from 'react-portable-text';

import { Container, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { IntroCard } from './IntroCard';

const useStyles = makeStyles((theme) => ({
  header: {
    color: '#002d5c',
    textAlign: 'center',
    marginBottom: '2rem',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },
  headerP: {
    textAlign: 'center',
    margin: '0 auto 3rem auto',
    lineHeight: '1.2',
    maxWidth: '1080px',
    [theme.breakpoints.down('sm')]: {
      textAlign: 'left',
    },
  },
  gridContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      marginTop: '20px',
    },
  },
}));

export const IntroCards = ({ intro, introCards, compare }) => {
  const classes = useStyles();

  return (
    <Container style={{ paddingTop: !compare && '2rem' }}>
      {intro && (
        <PortableText
          content={intro}
          serializers={{
            h2: ({ children }) => (
              <Typography variant='h2' className={classes.header}>
                {children}
              </Typography>
            ),
            normal: ({ children }) => (
              <Typography variant='body1' className={classes.headerP}>
                {children}
              </Typography>
            ),
            strong: ({ children }) => (
              <>
                <span style={{ color: '#D10066' }}>{children}</span>
                {compare && <br />}
              </>
            ),
          }}
        />
      )}

      <Grid container spacing={3} className={classes.gridContainer}>
        {introCards.map((card, index) => (
          <IntroCard key={index} card={card} />
        ))}
      </Grid>
    </Container>
  );
};
